<template>
  <div
    class="h-full flex flex-col items-center justify-center text-center text-sm xl:text-lg"
  >
    <span class="loading-text text-center">{{ $t('general.loading') }}</span>
    <div :id="id" class="relative flex-shrink-0 h-3 w-full mt-4 bullets-9">
      <div
        v-for="(_, idx) in Array(animationWidth)"
        :id="`${id}-${idx + 1}`"
        :key="idx"
        class="lh-loading absolute w-3 h-3"
        :class="{ 'top-0': idx === 0 }"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    id: {
      type: String,
      default: 'lh-loading',
    },
    animationWidth: {
      type: Number,
      default: 9,
    },
  },
})
</script>
